module.exports = __webpack_public_path__ + "static/media/stripe.91136c7e.svg";